var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright"},[_vm._v(" Copyright © 2017 - "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"https://www.qljy.com"}},[_vm._v("广州青鹿教育科技有限公司")]),_vm._v(" All Rights Reserved "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }